import { sub, add, isBefore, isToday, parse, format } from "date-fns";

import type { TPickupTimeFrame } from "../types";

const toUnixTime = (time: string): number => parse(time, "HH:mm", new Date()).getTime();

const timeWithCutoff = (time, cutoff = 0) =>
  format(sub(parse(time, "HH:mm", new Date()), { minutes: cutoff }), "HH:mm");

const getLatestPickupToday = (timeFrames: TPickupTimeFrame[]): string | undefined => {
  const todaysTimeFrame = timeFrames.find(({ date }) => isToday(date));
  if (!todaysTimeFrame) {
    return undefined;
  }

  const availableTimeFrom = [...(todaysTimeFrame.timeFrameFrom || [])]
    // Sort in case of wrong order of the results and reverse the original order
    // to search from latest time to earliest
    .sort((a, b) => toUnixTime(b) - toUnixTime(a))
    .find((time) => {
      const timeDate = parse(time, "HH:mm", new Date());

      return !isBefore(timeDate, add(new Date(), { minutes: todaysTimeFrame.cutoff || 0 }));
    });

  if (availableTimeFrom) {
    return timeWithCutoff(availableTimeFrom, todaysTimeFrame.cutoff);
  }

  return availableTimeFrom;
};
export default getLatestPickupToday;
